import * as yup from 'yup';

export const initialValues = {
  companyName: '',
  type: '',
  washHub: '',
  site: '',
  billingContact: '',
  collectionPoint: '',
};

export const validationSchema = yup.object().shape({
  companyName: yup.string().required('Company Name is a required field'),
  type: yup.string(),
  billingContact: yup.string(),
});
